<template>
  <DatePicker
    isRange
    expanded
    mode="date"
    :rules="rules"
    :model-value="range"
    @update:modelValue="$emit('rangeSelected', $event)"
  />
</template>

<script setup>
import { DatePicker } from "v-calendar";
import { ref } from "vue";

defineEmits(["rangeSelected"]);

defineProps({
  range: {
    type: Object,
  },
});

const rules = ref([
  {
    hours: 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0,
  },
  {
    hours: 23,
    minutes: 59,
    seconds: 59,
    milliseconds: 999,
  },
]);
</script>
